const updateProducts = (node, resp, context) => {
  const productsList = node.querySelector('[data-products-list]');

  // Get new products markup
  const newProductsHtml = new DOMParser()
    .parseFromString(resp, 'text/html')
    .querySelector('[data-products-list]').innerHTML;

  // Render markup based on prev or next
  if (context === 'prev') {
    productsList.innerHTML = newProductsHtml;
  } else {
    productsList.insertAdjacentHTML('beforeend', newProductsHtml);
  }
};

export default updateProducts;
